import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.homologation.cliqdrive.com.br",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json;version=v1_web",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
